import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { PrivilegesSnapshot, SecurityService } from '@bayclubs/utils';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class PrivilegesSnapshotResolverService  {
    constructor(private securityService: SecurityService) {}

    resolve(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): PrivilegesSnapshot | Observable<PrivilegesSnapshot> | Promise<PrivilegesSnapshot> {
        return this.securityService.getPrivilegesSnapshot$();
    }
}
